import { render, staticRenderFns } from "./DialogInfoKeyword.vue?vue&type=template&id=80c17b86"
import script from "./DialogInfoKeyword.vue?vue&type=script&lang=js"
export * from "./DialogInfoKeyword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports